import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

export default function CookieConsent() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="mx-auto max-w-4xl rounded-lg border border-border bg-card p-4 shadow-lg md:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
            <Cookie className="h-5 w-5 text-primary" />
          </div>
          
          <div className="flex-1 space-y-3">
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-semibold text-foreground">
                {t('cookies.title')}
              </h3>
              <button
                onClick={handleAcceptNecessary}
                className="rounded-full p-1 text-muted-foreground hover:bg-muted hover:text-foreground sm:hidden"
                aria-label={t('common.close')}
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            
            <p className="text-sm text-muted-foreground">
              {t('cookies.description')}{' '}
              <Link 
                to="/cookie-policy" 
                className="text-primary underline underline-offset-2 hover:text-primary/80"
              >
                {t('cookies.learnMore')}
              </Link>
            </p>
            
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              <Button 
                onClick={handleAcceptAll}
                className="w-full sm:w-auto"
              >
                {t('cookies.acceptAll')}
              </Button>
              <Button 
                onClick={handleAcceptNecessary}
                variant="outline"
                className="w-full sm:w-auto"
              >
                {t('cookies.acceptNecessary')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
